






























































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CatatanHarianBblStore from "@/store/modules/CatatanHarianBblStore";
import Service from "@/services/CatatanHarianBblService";
import { RUANG_OPTIONS, BblAlertItem } from "@/types/catatan_harian_bbl";
import { userModule } from "@/store/modules/user";
import { emptyDubowitzScores } from "@/utils/dubowitzScore";
import moment from "moment";

@Component({
  components: {
    BblDateNavigator: () => import("./BblDateNavigator.vue"),
    BblObservasiGrid: () => import("./BblObservasiGrid.vue"),
    BblAlertBanner: () => import("./BblAlertBanner.vue"),
    BblRekapIntakeOutput: () => import("./BblRekapIntakeOutput.vue"),
    BblDubowitzScoreCard: () => import("./BblDubowitzScoreCard.vue"),
  },
  inject: {
    isReadOnly: { default: () => () => false },
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class CatatanHarianBblPage extends Vue {
  @Prop({ required: true }) isActive!: boolean;
  isReadOnly!: () => boolean;
  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canEditForm(): boolean {
    if (this.readOnly) return false;
    return (
      userModule.canAccessForm("catatan_harian_bbl", "create") ||
      userModule.canAccessForm("catatan_harian_bbl", "edit")
    );
  }

  selectedDate = "";
  savingObs = false;
  verifyingDpjp = false;
  deleting = false;
  ruangOptions = RUANG_OPTIONS;
  saveTimeout: any = null;

  form: any = this.emptyForm();

  emptyForm() {
    return {
      bb_lahir: null,
      bb_sekarang: null,
      ruang: null,
      dubowitz_scores: emptyDubowitzScores(),
      catatan_umum: null,
      rekap_intake_output: {}
    };
  }

  get registerId() {
    return this.$route.params.register || this.$route.params.noReg || this.$route.params.registerId;
  }

  get pasienRm() {
    return this.$route.params.rm || this.$route.params.pasienRm;
  }

  get loading() {
    return CatatanHarianBblStore.loading;
  }

  get catatanList() {
    return CatatanHarianBblStore.catatanList;
  }

  get currentCatatan() {
    return CatatanHarianBblStore.currentCatatan;
  }

  get alerts(): BblAlertItem[] {
    return CatatanHarianBblStore.alerts;
  }

  get isDpjpVerified(): boolean {
    return this.currentCatatan ? !!this.currentCatatan.dpjp_signed_at : false;
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && this.registerId) {
      this.loadData();
    }
  }

  @Watch("currentCatatan")
  onCatatanChange(val: any) {
    if (val) {
      const empty = emptyDubowitzScores();
      this.form = {
        bb_lahir: val.bb_lahir,
        bb_sekarang: val.bb_sekarang,
        ruang: val.ruang,
        dubowitz_scores: {
          neuro: { ...empty.neuro, ...(val.dubowitz_scores?.neuro || {}) },
          fisik: { ...empty.fisik, ...(val.dubowitz_scores?.fisik || {}) }
        },
        catatan_umum: val.catatan_umum,
        rekap_intake_output: val.rekap_intake_output ? { ...val.rekap_intake_output } : {},
      };
    }
  }

  mounted() {
    if (this.isActive && this.registerId) {
      this.loadData();
    }
  }

  async loadData() {
    await CatatanHarianBblStore.fetchByRegister(this.registerId);
    if (this.catatanList.length > 0) {
      const lastDay = this.catatanList[this.catatanList.length - 1];
      this.selectedDate = lastDay.tanggal;
      await CatatanHarianBblStore.fetchByDate({
        registerId: this.registerId,
        tanggal: this.selectedDate
      });
    }
  }

  async onSelectDate(tanggal: string) {
    this.selectedDate = tanggal;
    await CatatanHarianBblStore.fetchByDate({
      registerId: this.registerId,
      tanggal
    });
  }

  async onCarryForward() {
    const today = localISODate();
    await CatatanHarianBblStore.carryForward({
      registerId: this.registerId,
      data: {
        tanggal: today,
        pasien_rm: this.pasienRm
      }
    });
    await CatatanHarianBblStore.fetchByRegister(this.registerId);
    this.selectedDate = today;
  }

  saveParent() {
    if (this.saveTimeout) clearTimeout(this.saveTimeout);
    const target = this.currentCatatan;
    if (!target) return;
    const tanggal = target.tanggal || this.selectedDate;
    const payload = {
      register_id: target.register_id || this.registerId,
      pasien_rm: target.pasien_rm || this.pasienRm,
      tanggal,
      ...JSON.parse(JSON.stringify(this.form))
    };
    this.saveTimeout = setTimeout(async () => {
      await CatatanHarianBblStore.updateCatatan({ id: target.id, data: payload });
      if (this.selectedDate && this.selectedDate !== tanggal) {
        await CatatanHarianBblStore.fetchByDate({
          registerId: this.registerId,
          tanggal: this.selectedDate
        });
      }
    }, 800);
  }

  onDubowitzChange(payload: { scores: any; total: number; umur_kehamilan: number | null }) {
    this.form.dubowitz_scores = payload.scores;
    this.saveParent();
  }

  onUpdateRekap(rekap: any) {
    this.form.rekap_intake_output = rekap;
    this.saveParent();
  }

  async onSaveObservasi(data: any) {
    if (!this.currentCatatan) return;
    this.savingObs = true;
    try {
      await Service.storeObservasi(this.currentCatatan.id, data);
      await CatatanHarianBblStore.fetchByDate({
        registerId: this.registerId,
        tanggal: this.selectedDate
      });
    } finally {
      this.savingObs = false;
    }
  }

  async onDeleteObservasi(obsId: number) {
    this.savingObs = true;
    try {
      await Service.deleteObservasi(obsId);
      await CatatanHarianBblStore.fetchByDate({
        registerId: this.registerId,
        tanggal: this.selectedDate
      });
    } finally {
      this.savingObs = false;
    }
  }

  async onVerifyDpjp() {
    if (!this.currentCatatan || this.verifikasiTerkunci) return;
    if (!confirm("Verifikasi catatan harian BBL atas nama DPJP yang sedang login? Tindakan tercatat di audit trail.")) {
      return;
    }
    this.verifyingDpjp = true;
    try {
      await CatatanHarianBblStore.verifyDpjp(this.currentCatatan.id);
      await CatatanHarianBblStore.fetchByRegister(this.registerId);
    } catch (e) {
      // Error handled by service
    } finally {
      this.verifyingDpjp = false;
    }
  }

  async onDelete() {
    if (!confirm("Yakin ingin menghapus catatan hari ini?")) return;
    if (!this.currentCatatan) return;
    this.deleting = true;
    try {
      await CatatanHarianBblStore.deleteCatatan(this.currentCatatan.id);
      await CatatanHarianBblStore.fetchByRegister(this.registerId);
      if (this.catatanList.length > 0) {
        this.selectedDate = this.catatanList[this.catatanList.length - 1].tanggal;
        await CatatanHarianBblStore.fetchByDate({
          registerId: this.registerId,
          tanggal: this.selectedDate
        });
      } else {
        this.selectedDate = "";
      }
    } finally {
      this.deleting = false;
    }
  }

  cetakPdf() {
    if (this.currentCatatan) {
      Service.printPdf(this.currentCatatan.id);
    }
  }

  formatDateTime(val: string | null): string {
    return val ? moment(val).format("DD-MM-YYYY HH:mm") : "";
  }
}
